import { useState, useCallback } from 'react';

export function useToast() {
  const [toast, setToast] = useState(null);

  const mostrarToast = useCallback((texto) => {
    setToast({ texto, id: Date.now() });
    setTimeout(() => setToast(null), 2500);
  }, []);

  return { toast, mostrarToast };
}
